import { render, staticRenderFns } from "./BadgeManagementWidget.vue?vue&type=template&id=edcdc17a"
import script from "./BadgeManagementWidget.vue?vue&type=script&lang=js"
export * from "./BadgeManagementWidget.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports